var gui = (typeof require != "undefined") ? require('nw.gui') : false;

// Constructor
function Caisse(datafile) {
	this.data = {};
	this.datafile = datafile;
	this.lastClick = millis();
	this.resetDelay = 30000;
	this.previewAnimated = false;

	// Touch event valid with the NWJS  version <= 38
	this.isTouchEnabled = (('ontouchstart' in window) || window.navigator.maxTouchPoints > 0 || (window.DocumentTouch && document instanceof DocumentTouch));
	this.touchEvent = this.isTouchEnabled ? "touchstart" : "click";

	this.init();
	this.initEvents();

	// Init audio
	this.audio = new Audio();
	$("body").append(this.audio.createDOM());
}

Caisse.prototype.init = function () {

	console.log("loading file ", this.datafile);

	// Load default settings
	$.ajax({
		dataType: "json",
		type: 'GET',
		url: this.datafile,
		async: false,
		success: $.proxy(this.dataLoaded, this),
		error: function () {
			console.log("error loading file");
		}
	});

	// Add update date interval
	this.updateDate();
	setInterval($.proxy(function () {
		this.updateDate();
	}, this), 1000);

	setInterval($.proxy(function (e) {
		this.checkTimer();
	}, this), 1000);

	setInterval($.proxy(function () {
		this.initEvents();
	}, this), 5000);

	// TEMP : add a invoice item
	//this.addInvoiceItem(0);
	//this.addInvoiceItem(1);
}

Caisse.prototype.initEvents = function (data) {

	// Callbacks
	$("#grid").off(this.touchEvent).on(this.touchEvent, ".item", $.proxy(function (e) {
		this.selectGridItem(e.currentTarget);
	}, this));
	$("#invoice-items").off(this.touchEvent).on(this.touchEvent, ".item .delete", $.proxy(function (e) {
		this.removeInvoiceItem($(e.currentTarget).parents(".item"));
	}, this));
	$("#invoice-reset-all").off(this.touchEvent).on(this.touchEvent, $.proxy(function (e) {
		this.reset();
	}, this));

	// Timeout related
	$(document).off("click touchstart mousedown").on("click touchstart mousedown", $.proxy(function (e) {
		this.resetTimer();
	}, this));

	if (gui) {
		$(window).off("keydown").on('keydown', $.proxy(function (e) {
			this.keyPressed(e)
		}, this));
	}
}

Caisse.prototype.keyPressed = function (e) {

	if (e.keyCode == 80) {
		// P
		this.print("money20.pdf", 1, this.printerName);
	} else if (e.keyCode == 27) {
		// Escape
		gui.App.quit();
	} else if (e.keyCode == 73 || e.keyCode == 67) {
		// Key I or C
		gui.Window.get().showDevTools();
	}
}

Caisse.prototype.dataLoaded = function (data) {

	// Save data
	this.data = data;

	// Create grid
	data.items.forEach($.proxy(function (item) {
		this.addGridItem(item["name_fr"], item["name_en"], item["category"], item["image"], item);
	}, this));

}

// Grid item selection
Caisse.prototype.selectGridItem = function (el) {
	var image = $(el).data("image");
	this.previewItem(image);
	this.addInvoiceItem($(el).data("id"))
};

// Refresh preview image on invoice
Caisse.prototype.previewItem = function (image) {
	var style = "background-image: url('" + image + "'); background-size: 120%; background-position: 40% 0%";

	// Do not allow animation if not completed
	if (this.previewAnimated) return;
	this.previewAnimated = true;

	// Animation using Transit
	$('#preview').transition({
		duration: 350,
		perspective: '1000px',
		rotateX: '90deg',
		easing: 'easeInQuad',
		complete: $.proxy(function () {
			$("#preview .image").attr("style", style);
			$('#preview').css('rotateX', "-90deg");
			$('#preview').transition({
				duration: 350,
				easing: 'easeOutQuad',
				perspective: '1000px',
				rotateX: '0deg',
				complete: $.proxy(function () {
					this.previewAnimated = false;
				}, this)
			});
		}, this)
	});
};


// Calculate total and subtotals (tps, tvq)
Caisse.prototype.calculateTotal = function () {

	var subtotal = 0;
	var subtotalTax = 0;
	var tps = 0;
	var tvq = 0;
	var total = 0;

	// Calculate subtotal
	var holder = $("#invoice-items .item").each(function (i, n) {
		var qte = $(".col-qte", n).text();
		var price = $(n).data("price");
		subtotal += (qte * price);
		if ($(n).data("taxable") == true) {
			subtotalTax += (qte * price);
		}
	});
	//subtotalTax = subtotal;

	// Calculate TPS
	tps = parseFloat((subtotalTax * 0.05).toPrecision(2));

	// Calculate TVQ
	tvq = parseFloat((subtotalTax * 0.09975).toPrecision(2));

	// Calculate Total
	total = (subtotal + tps + tvq);

	// Add prices to DOM
	$("#invoice-footer-subtotal .col-price").text(subtotal.toFixed(2) + " $");
	$("#invoice-footer-tps .col-price").text(tps.toFixed(2) + " $");
	$("#invoice-footer-tvq .col-price").text(tvq.toFixed(2) + " $");
	$("#invoice-footer-total .col-price").text(total.toFixed(2) + " $");
};


// Remove all items from invoice
Caisse.prototype.clearInvoice = function () {
	$("#invoice-items .item").each($.proxy(function (i, n) {
		this.removeInvoiceItem(n);
	}, this));
};

// Update date and time
Caisse.prototype.updateDate = function () {
	$("#invoice-header-hour").text(getDate("hour"));
	$("#invoice-header-date .fr").text(getDate("fr"));
	$("#invoice-header-date .en").text(getDate("en"));
};

// Add a button to a menu or the other
Caisse.prototype.addInvoiceItem = function (id) {
	var holder = $("#invoice-items");
	var itemData = this.data.items[id];
	var domId = "invoice-item-" + id;

	// Audio play
	this.audio.play("Clap-3-cropped");

	if (holder.find("#" + domId).length == 0) {

		// Add item on invoive
		var el = $('<div class="item" id="' + domId + '"><div class="col col-delete"><div class="delete">X</div></div><div class="col col-qte">1</div><div class="col col-name"><span class="fr">' + itemData["name_fr"] + '</span><span class="en">' + itemData["name_en"] + '</span></div><div class="col col-price">' + itemData["price"].toFixed(2) + ' $</div></div>');
		el.data("price", itemData["price"]);
		el.data("taxable", itemData["taxable"]);
		holder.append(el);

	} else {

		// Already on invoice, increase count
		var itemQte = parseInt(holder.find("#" + domId + " .col-qte").text());
		var total = ((itemQte + 1) * itemData["price"]).toFixed(2) + " $";
		holder.find("#" + domId + " .col-qte").text(itemQte + 1);
		holder.find("#" + domId + " .col-price").text(total);
	}

	// Update total
	this.calculateTotal();

	// Drag scroll
	dragscroll.reset()

	// Scroll invoice down
	$("#invoice-items").scrollTop(10000);
};

Caisse.prototype.removeInvoiceItem = function (el) {
	$(el).fadeOut(200, $.proxy(function (i, n) {
		$(el).remove();
		this.calculateTotal();
	}, this));
}

// Add a button to a menu or the other
Caisse.prototype.addGridItem = function (name_fr, name_en, category_id, image, data) {
	var holder = $("#grid");
	var count = holder.find(".item").length;
	var style = "background-image: url('" + image + "'); background-size: cover;";

	// Create DOM item
	var el = $('<a class="item category-' + category_id + ' item-' + (count + 1) + '"><div class="image" style="' + style + '"></div><div class="label"><span class="fr">' + name_fr + '</span><span class="en">' + name_en + '</span></div></a>');
	holder.append(el);

	// Add data
	el.data("id", count);
	Object.keys(data).forEach(function (key) {
		el.data(key, data[key]);
	});
};


Caisse.prototype.resetTimer = function (data) {
	this.lastClick = millis();
}

Caisse.prototype.checkTimer = function (data) {
	var noActionSince = millis() - this.lastClick;
	if (noActionSince > this.resetDelay) {
		this.reset();
	}
}

Caisse.prototype.reset = function () {
	this.lastClick = millis();
	this.clearInvoice();
};

// Expose Caisse
window.Caisse = Caisse;